import React from 'react'

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";

import {
    withStyles,
    TextField, MenuItem, Button, Typography, Grid, CircularProgress
} from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useHistory } from 'react-router-dom'

import { withFormik } from "formik";
import * as Yup from "yup";


const styles = (theme) => ({
    card: {
        maxWidth: 420,
        margin: 12
    },
    container: {
        display: 'flex',
        justifyContet: 'center'
    },
    actions: {
        float: 'right'
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    chkErrorMsg: {
        color: theme.palette.error.main,
        marginLeft: 14,
        marginRight: 14
    },
    progressDiv: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 6
    },
    cardDiv: {
        padding: 15
    },
    btnsDiv: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 15,
    }
})


const FormikForm_ = (props) => {
    const theme = useTheme()
    const history = useHistory();
    const {
        classes,
        values,
        touched,
        errors,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset
    } = props;

    return (
        <div className={classes.root}>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>

                    <Card className={classes.cardDiv}>

                        <form onSubmit={handleSubmit}>

                            <TextField
                                id="email"
                                label="Email"
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                type="email"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={touched.email ? errors.email : ""}
                                error={touched.email && Boolean(errors.email)}
                            />


                            <div className={classes.btnsDiv}>
                                <div className={classes.progressDiv}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmitting}
                                        type="submit"
                                    >
                                    Reset Password
                                    </Button>
                                    {isSubmitting && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </div>
                                <span >or</span>
                                <Button
                                    className="capitalize"
                                    onClick={() =>
                                        history.push("/signin")
                                    }
                                    variant="outlined"
                                    style={{ marginLeft: 8, border: '1px lightgrey' }}
                                >
                                Sign In
                                </Button>
                            </div>


                        </form>
                    </Card>
                </Grid>
            </Grid>

        </div>
    )
}

const FormikForm = withFormik({
    mapPropsToValues: ({
        email,
    }) => {
        return {
            email: email || "registeredemail@example.com",
        }
    },
    validationSchema: Yup.object().shape({
        email: Yup.string()
            .email("Enter a valid email")
            .required("Email is required"),

    }),
    handleSubmit: (values, formikBag) => {
        console.log(formikBag.props)
        const { props, setSubmitting } = formikBag
        setTimeout(() => {
            //submtting
            alert(JSON.stringify(values, null, 2))
            setSubmitting(false)
            props.history.push("/signin")
        }, 1000)
    }
}
)(FormikForm_)
export default withStyles(styles)(FormikForm); 